import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ByobService {

  private apiUrl = environment.apiUrl + 'byob';

  constructor(private http: HttpClient) {}

  /**
   * Load BYOB Products
   * Response:
   * {
   *   boxes: [],
   *   books: [],
   *   stationery: []
   * }
   */
  getAvailableItems(): Observable<any> {
    return this.http.get(`${this.apiUrl}/items`);
  }

  /**
   * Create New Box
   */
  createByobBox(userId: number | null = null): Observable<any> {

    return this.http.post(
      `${this.apiUrl}/create`,
      {
        user_id: userId
      }
    );

  }

  /**
   * Load Existing Box
   */
  getByobBox(boxId: number): Observable<any> {

    return this.http.get(
      `${this.apiUrl}/box/${boxId}`
    );

  }

  /**
   * Add Product
   */
  addItemToBox(
    boxId: number,
    productId: number,
    quantity: number = 1
  ): Observable<any> {

    return this.http.post(
      `${this.apiUrl}/add-item`,
      {
        box_id: boxId,
        product_id: productId,
        quantity: quantity
      }
    );

  }

  /**
   * Update Quantity
   */
  updateItemQuantity(
    boxId: number,
    productId: number,
    quantity: number
  ): Observable<any> {

    return this.http.put(
      `${this.apiUrl}/update-item`,
      {
        box_id: boxId,
        product_id: productId,
        quantity: quantity
      }
    );

  }

  /**
   * Remove Product
   */
  removeItemFromBox(
    boxId: number,
    productId: number
  ): Observable<any> {

    return this.http.request(
      'delete',
      `${this.apiUrl}/remove-item`,
      {
        body: {
          box_id: boxId,
          product_id: productId
        }
      }
    );

  }

  /**
   * Delete Entire Box (Optional)
   */
  deleteBox(boxId: number): Observable<any> {

    return this.http.request(
      'delete',
      `${this.apiUrl}/delete-box`,
      {
        body: {
          box_id: boxId
        }
      }
    );

  }

}